export const SEND_MESSAGE_GPT_START = '[SEND_MESSAGE_GPT] START'
export const SEND_MESSAGE_GPT_END = '[SEND_MESSAGE_GPT] END'
export const SEND_MESSAGE_GPT_SUCCESS = '[SEND_MESSAGE_GPT] SUCCESS'
export const SEND_MESSAGE_GPT_FAILURE = '[SEND_MESSAGE_GPT] FAILURE'
export const SET_MESSAGE_GPT_INPUT = '[SET_MESSAGE_GPT_INPUT] SET INPUT'
export const SET_ACTIVE_STEP = 'SET_ACTIVE_STEP'
export const SET_ACTIVE_TRAINING = 'SET_ACTIVE_TRAINING'
